import _ from "lodash";

export const cleanPostcodeErrors = (errors) => ({..._.omit(errors, ['postcode', 'address1', 'address2', 'address3', 'address4', 'city'])});

export const mapPostcodes = (postcodes = []) => postcodes.map((p, i) => {
    const {line_1, line_2, line_3, line_4} = p;
    return {
        key: i,
        value: `${line_1 && line_1} ${line_2 && line_2}  ${line_3 && line_3}  ${
            line_4 && line_4
        } `.trim(),
    };
});
